import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=0f0015c4&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "./contact.vue?vue&type=style&index=0&id=0f0015c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0015c4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StoryblokImage: require('/opt/build/repo/components/StoryblokImage.vue').default,AppButton: require('/opt/build/repo/components/AppButton.vue').default})
